import SearchBar from './searchBar.view';

export default SearchBar;
